export default {
    /**Tỉnh thành */
    Province: 1,
    /**Quận Huyện */
    District: 2,
    /**xã phường */
    Ward: 3
}